import { connect } from 'react-redux';
import React, { Component } from 'react';
import { renderKBInput, withReduxFormFieldProps } from 'components/formAdapters/reduxFormAdapters';
import { Field, reduxForm } from 'redux-form';

import * as valid from 'utils/validate';
import { KBFormError,
KBButton } from
'components';

var VisitTypeEditNameForm = class extends React.Component {constructor(props) {super(props);this.saveName = this.saveName.bind(this);}saveName(
  model) {
    const { updateCurrentType, currentVisitType } = this.props;
    let newVisitType = Object.assign({}, currentVisitType);
    newVisitType.name = model.name;
    return updateCurrentType(newVisitType);
  }render()

  {
    const {
      fields: { name },
      error,
      submitting,
      handleSubmit } =
    this.props;

    return (
      <form onSubmit={handleSubmit(this.saveName)}>
        <div className="kb-form-container visit-setting-block">
          <KBFormError error={error} />
          <div className="kb-row">
            <Field name="name" component={renderKBInput}
            title="访客类型名称"
            className="kb-form-group kb-div-210 kb-form-alone"
            isRequired={true}
            />

          </div>
          <KBButton
          className="certain-btn"
          type="submit"
          submitting={submitting}>

            保存
          </KBButton>
        </div>
      </form>);

  }};


function mapStateToProps(state, props) {
  const { currentVisitType } = props;

  return {
    initialValues: {
      name: currentVisitType.name || '' } };


}

function mapDispatchToProps(dispatch) {
  return {};
}

const validate = values => {
  const errors = {};

  if (valid.required(values.name)) {
    errors.name = '请输入访客类型名称';
  }

  return errors;
};

const LEGACY_FORM_FIELDS = [
  "name"
];

const formConfig = {
  form: 'VisitTypeEditNameForm',
  validate: validate,
  touchOnBlur: false };


export default connect(mapStateToProps, mapDispatchToProps)(reduxForm(formConfig)(withReduxFormFieldProps('VisitTypeEditNameForm', LEGACY_FORM_FIELDS)(VisitTypeEditNameForm)));
